import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HcToasterService } from '@healthcatalyst/cashmere';
import { Injectable } from '@angular/core';
import { HttpErrorResponseToastHandler } from './http-error-response-toast-handler';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {
    baseUrl: string = environment.ideaApiUrl;
    public constructor(private toasterService: HcToasterService) {}

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.indexOf(this.baseUrl) >= 0) {
            return next.handle(request).pipe(
                catchError((error: HttpErrorResponse) => {
                    const errorWithHandler = new HttpErrorResponseToastHandler(error, this.toasterService);
                    return throwError(errorWithHandler);
                })
            );
        }
        return next.handle(request);
    }
}
